import React, { useState, useEffect } from 'react'
import { Card } from 'antd'
import { useSelector } from 'react-redux'
import moment from 'moment'
import { getDashboardTag, getDashboardJob } from '../../services/dashboard/dashboard'
import AntdTable from '../../components/table/AntdTable'
import { formatMessage, numFormat } from '../../utils/common'

let intervalRef = null

const Dashboard = props => {
  const commonStore = useSelector(state => state.commonStore)

  const [tagTableList, setTagTableList] = useState([])
  const [tableLoading, setTableLoading] = useState(true)
  const [tableList, setTableList] = useState([])
  const [pageTime, setPageTime] = useState('')

  useEffect(() => {
    intervalRef = setInterval(() => {
      searchDataFun()
    }, 300000)
    searchDataFun()
    return () => {
      // 关闭定时器
      clearInterval(intervalRef)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getOperationType = operationType => {
    let type = ''
    switch (operationType) {
      case 'NSP':
        type = 'Refresh NSP NFC SKU'
        break
      case 'PROD_FINDER':
        type = 'Refresh PF NFC SKU'
        break
      case 'RFID':
        type = 'Refresh RFID SKU'
        break
      case 'WAVE_RUN':
        type = 'Refresh WAVE RUN'
        break
      case 'COPY_1027_WAVE_RUN':
        type = 'Copy 1027 file from SML'
        break
      default:
        break
    }
    return type
  }

  const searchDataFun = () => {
    setPageTime(new Date().toLocaleString())
    getDashboardTag({}).then(res => {
      const dataSource = []
      if (res.errorCode === '200') {
        const keys = Object.keys(res.resultData)
        for (let i = 0; i < keys.length; i++) {
          const key = keys[i]
          const value = res.resultData[key]
          dataSource.push({
            operation: key + ' Send To Ant',
            total: value.total,
            fail: value.fail
          })
        }
        setTableLoading(false)
        setTagTableList(dataSource)
      }
    })
    getDashboardJob({}).then(res => {
      const dataSource = []
      if (res.errorCode === '200') {
        for (const key in res.resultData) {
          if (Object.hasOwnProperty.call(res.resultData, key)) {
            const value = res.resultData[key]
            dataSource.push({
              operation: getOperationType(key),
              status: value.logLevel === 'INFO' || value.logLevel === 'WARN' ? 'Success' : 'Fail',
              updateTime: value.operateTime
            })
          }
        }
        setTableList(dataSource)
      }
    })
  }

  const tagTableColumns = [
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.operation'),
      dataIndex: 'operation'
    },
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.total'),
      dataIndex: 'total',
      render: text => {
        return numFormat(text)
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.fail'),
      dataIndex: 'fail',
      render: text => {
        return numFormat(text)
      }
    }
  ]

  const tableColumns = [
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.operation'),
      dataIndex: 'operation'
    },
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.status'),
      dataIndex: 'status',
      render: text => {
        return <span style={{ color: text === 'Fail' ? 'red' : 'black' }}>{text}</span>
      }
    },
    {
      title: formatMessage(commonStore, 'languageObj.dashboard.updateTime'),
      dataIndex: 'updateTime',
      render: text => {
        return moment(new Date(text)).format('YYYY-MM-DD HH:mm')
      }
    }
  ]

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100%' }}>
      <div style={{ width: '70%' }}>
        <Card bordered={false} bodyStyle={{ padding: 4 }}>
          <div className="content-container">
            <div className="mb15" style={{ fontWeight: 600 }}>
              {formatMessage(commonStore, 'languageObj.dashboard.refreshTime')}
              {pageTime}
            </div>
            <AntdTable
              title={() => <div>{formatMessage(commonStore, 'languageObj.dashboard.history')}</div>}
              bordered
              dataSource={tagTableList}
              columns={tagTableColumns}
              loading={tableLoading}
            />
          </div>
          <div className="content-container">
            <AntdTable dataSource={tableList} columns={tableColumns} />
          </div>
        </Card>
      </div>
    </div>
  )
}
export default Dashboard
